import { CheckCircle2, Clock3, ExternalLink, ListPlus, PencilLine, Utensils } from "lucide-react";
import { Link } from "react-router-dom";

import { formatPersianNumber as numberFormatter } from "../../utils/persianNumber";
const dateFormatter = new Intl.DateTimeFormat("fa-IR", {
  month: "short",
  day: "numeric",
});

const formatDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : dateFormatter.format(date);
};

const CardHeader = ({ badge }) => (
  <div className="flex items-center justify-between gap-3">
    <h2 id="menu-status-title" className="flex items-center gap-2 text-sm font-extrabold text-accent">
      <Utensils size={16} className="text-primary" aria-hidden="true" />
      منو
    </h2>
    {badge}
  </div>
);

export default function MenuStatusSection({ menu, menuLink, error }) {
  if (error) {
    return (
      <section className="rounded-2xl border border-gray-200 bg-white p-4" aria-labelledby="menu-status-title">
        <CardHeader />
        <p className="mt-2 text-xs text-gray-500">اطلاعات منو در حال حاضر در دسترس نیست.</p>
      </section>
    );
  }

  if (!menu.exists) {
    return (
      <section className="rounded-2xl border border-gray-200 bg-white p-4" aria-labelledby="menu-status-title">
        <CardHeader />
        <p className="mt-2 text-xs leading-5 text-gray-500">هنوز منویی برای رستوران ساخته نشده است.</p>
        <Link
          to="/dashboard/edit-menu"
          className="mt-3 inline-flex min-h-9 items-center gap-1.5 rounded-lg bg-primary px-3.5 text-sm font-bold text-white hover:bg-[#e8731f] focus:outline-none focus:ring-4 focus:ring-primary/20"
        >
          <ListPlus size={16} aria-hidden="true" />
          ساخت منو
        </Link>
      </section>
    );
  }

  const updatedAt = formatDate(menu.updatedAt);
  const editRoute = `/dashboard/edit-menu/${menu.menuId}`;

  const badge = (
    <span className={`inline-flex items-center gap-1 text-xs font-bold ${menu.isPublished ? "text-secondary" : "text-amber-700"}`}>
      {menu.isPublished ? <CheckCircle2 size={14} aria-hidden="true" /> : <Clock3 size={14} aria-hidden="true" />}
      {menu.isPublished ? "منتشر شده" : "پیش‌نویس"}
    </span>
  );

  return (
    <section className="rounded-2xl border border-gray-200 bg-white p-4" aria-labelledby="menu-status-title">
      <CardHeader badge={badge} />

      <p className="mt-3 truncate text-sm font-bold text-gray-800">{menu.title || "منوی رستوران"}</p>
      <p className="mt-0.5 text-xs text-gray-500">
        {numberFormatter(menu.itemCount)} آیتم
        {updatedAt && <> · بروزرسانی {updatedAt}</>}
      </p>

      <div className="mt-3 flex gap-2">
        <Link
          to={editRoute}
          className="inline-flex min-h-9 flex-1 items-center justify-center gap-1.5 rounded-lg bg-primary px-3 text-sm font-bold text-white hover:bg-[#e8731f] focus:outline-none focus:ring-4 focus:ring-primary/20"
        >
          <PencilLine size={15} aria-hidden="true" />
          ویرایش منو
        </Link>
        {menu.isPublished && menuLink && (
          <Link
            to={`/menu/${menuLink}`}
            className="inline-flex min-h-9 flex-1 items-center justify-center gap-1.5 rounded-lg border border-gray-200 px-3 text-sm font-bold text-accent hover:border-primary/40 hover:bg-gray-50 focus:outline-none focus:ring-4 focus:ring-primary/15"
          >
            <ExternalLink size={14} aria-hidden="true" />
            منوی آنلاین
          </Link>
        )}
      </div>
    </section>
  );
}
